/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ebc30b99-4d98-4bf5-8baf-213e1ba96b29",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Isb5wK5Za",
    "aws_user_pools_web_client_id": "31bsuuv26iai2knecusto3uo9d",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://wqeyfeozu5ddrmtftc7m35td4u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "PluselectApi",
            "endpoint": "https://slv3jxtg39.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
